import axios from 'axios';
import { DEFAULT_AXIOS_CONFIG } from './userService';
import { resolveGatewayBackedServiceBaseUrl } from './serviceBaseUrl';

const USER_SERVICE_URL = resolveGatewayBackedServiceBaseUrl(process.env.REACT_APP_USER_SERVICE_URL);

const getUserPreferences = async () => {
    const response = await axios.get(
        `${USER_SERVICE_URL}/api/users/me/preferences`,
        DEFAULT_AXIOS_CONFIG
    );
    return response.data;
};

const updateUserPreferences = async (payload) => {
    const response = await axios.patch(
        `${USER_SERVICE_URL}/api/users/me/preferences`,
        payload,
        DEFAULT_AXIOS_CONFIG
    );
    return response.data;
};

const userPreferencesService = {
    getUserPreferences,
    updateUserPreferences,
};

export default userPreferencesService;
